import { format } from "date-fns";
import { fromPromise, setup } from "xstate";

import { tauriApi } from "~/state/api/tauri";

export const initRepoMachine = setup({
	types: {
		context: {} as {
			path: string;
		},
		input: {} as {
			path: string;
		},
	},
	actors: {
		gitInit: fromPromise<void, { path: string }>(async ({ input }) => {
			await tauriApi.init(input);
		}),
		gitCommit: fromPromise<void, { path: string }>(async ({ input }) => {
			const prettyTimestamp = format(new Date(), "PPppp");

			await tauriApi.commit({ ...input, message: `🚀 Initial commit at ${prettyTimestamp}` });
		}),
	},
}).createMachine({
	id: "init-repo",
	initial: "initializing",
	context: ({ input }) => ({
		path: input.path,
	}),
	states: {
		initializing: {
			invoke: {
				src: "gitInit",
				input: ({ context }) => ({ path: context.path }),
				onError: {
					actions: ({ event }) => {
						throw new Error("Failed to initialize git repository", {
							cause: event.error,
						});
					},
					target: "done",
				},
				onDone: {
					target: "creatingFirstCommit",
				},
			},
		},
		creatingFirstCommit: {
			invoke: {
				src: "gitCommit",
				input: ({ context }) => ({ path: context.path }),
				onError: {
					actions: ({ event }) => {
						throw new Error("Failed to create first commit", { cause: event.error });
					},
					target: "done",
				},
				onDone: {
					target: "done",
				},
			},
		},
		done: {
			type: "final",
		},
	},
});
